'use client';

import { useNewsletter } from '@/hooks/use-newsletter';
import { Input } from '@headlessui/react';
import { useState } from 'react';

export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const { subscribe, isLoading, error, success, message } = useNewsletter();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      await subscribe(email);
      
      // Clear email on successful subscription
      if (!error) {
        setEmail('');
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col gap-4 sm:flex-row">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isLoading || success}
          className="focus:ring-primary-blue flex w-full rounded-md border border-gray-300 bg-white px-4 py-2 focus:ring-2 focus:outline-none disabled:opacity-50 md:w-3/5"
          required
        />
        <button
          type="submit"
          disabled={isLoading || success || !email.trim()}
          className="text-grey-700 hover:bg-primary-blue rounded-md bg-white px-6 py-2 text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:text-white"
        >
          {isLoading ? 'Subscribing...' : success ? 'Subscribed!' : 'Subscribe'}
        </button>
      </div>

      {/* Success message */}
      {success && message && (
        <div className="mt-2 text-sm text-green-600 flex items-center">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          {message}
        </div>
      )}

      {/* Error message */}
      {error && (
        <div className="mt-2 text-sm text-red-600">
          {error}
        </div>
      )}

      {/* Default helper text */}
      {!error && !success && (
        <p className="mt-2 text-sm text-gray-600">
          Get exclusive updates and special offers delivered to your inbox.
        </p>
      )}
    </form>
  );
} 